<div class="relative inline-block text-start">
  <!-- Profile Button -->
  <lib-profile-dropdown-button
    [isOpen]="isOpen()"
    (toggleDropdown)="toggleDropdown()" />

  <!-- Dropdown Menu -->
  @if (isOpen()) {
    <div
      class="absolute end-0 z-10 mt-sm w-82 origin-top-end rounded-md bg-white py-2xl px-lg shadow-lg"
      role="menu"
      aria-orientation="vertical"
      aria-labelledby="user-menu-button"
      libClickOutSide
      (clickOutside)="closeDropdown()"
      tabindex="-1">
      @if (isMainMode()) {
        <!-- Main menu content -->
        <lib-profile-dropdown-menu
          [profileMenuItems]="profileMenuItems()"
          (action)="selectMenuItem($event)" />
      } @else {
        <lib-profile-dropdown-sub-menu
          [selectedMenuItem]="selectedMenuItem()"
          [subMenuItems]="subMenuItems()"
          [selectedSubMenuItem]="selectedSubMenuItem()"
          (applyMainMode)="isMainMode.set(true)"
          (action)="selectSubMenuItem($event)" />
      }
    </div>
  }
</div>
